import { useTranslation } from "react-i18next";
import { ApiError } from "./api";

export function useFormat() {
  const { i18n } = useTranslation();
  const locale = i18n.resolvedLanguage === "id" ? "id-ID" : "en-US";
  const dateTime = new Intl.DateTimeFormat(locale, { dateStyle: "medium", timeStyle: "short" });
  const relative = new Intl.RelativeTimeFormat(locale, { numeric: "auto" });
  const number = new Intl.NumberFormat(locale);

  return {
    dateTime: (iso: string | null | undefined) => (iso ? dateTime.format(new Date(iso)) : "—"),
    relative: (iso: string | null | undefined) => {
      if (!iso) return "—";
      const diffSec = Math.round((new Date(iso).getTime() - Date.now()) / 1000);
      const abs = Math.abs(diffSec);
      if (abs < 60) return relative.format(diffSec, "second");
      if (abs < 3600) return relative.format(Math.round(diffSec / 60), "minute");
      if (abs < 86_400) return relative.format(Math.round(diffSec / 3600), "hour");
      return relative.format(Math.round(diffSec / 86_400), "day");
    },
    number: (n: number) => number.format(n),
  };
}

/** Human-readable error message, translated when the code is known. */
export function useErrorMessage() {
  const { t, i18n } = useTranslation();
  return (err: unknown): string => {
    if (err instanceof ApiError) {
      if (err.code === "network_error") return t("errors.network");
      const key = `errors.codes.${err.code}`;
      if (i18n.exists(key)) return t(key as never);
      return err.message;
    }
    return err instanceof Error ? err.message : t("errors.generic");
  };
}

export function shortId(id: string) {
  return id.slice(-8);
}
